(() => {
    if (document.documentElement.dataset.copyButtonInit) {
        return;
    }

    document.documentElement.dataset.copyButtonInit = 'true';

    const COPY_FEEDBACK_DURATION = 2000;
    const copyFeedbackTimeouts = new WeakMap();

    document.addEventListener('click', (event) => {
        const button = event.target.closest('.btn--copy');

        if (!button) {
            return;
        }

        const codeElement = button.querySelector('[role="presentation"]');
        const code = (codeElement?.textContent ?? button.textContent).trim();

        navigator.clipboard.writeText(code).then(() => {
            button.classList.add('is-copied');

            const defaultAriaLabel = button.dataset.defaultAriaLabel;
            const copiedAriaLabel = button.dataset.copiedAriaLabel;

            if (copiedAriaLabel) {
                button.setAttribute('aria-label', copiedAriaLabel);
            }

            const existingTimeout = copyFeedbackTimeouts.get(button);

            if (existingTimeout) {
                clearTimeout(existingTimeout);
            }

            copyFeedbackTimeouts.set(
                button,
                setTimeout(() => {
                    button.classList.remove('is-copied');

                    if (defaultAriaLabel) {
                        button.setAttribute('aria-label', defaultAriaLabel);
                    }

                    copyFeedbackTimeouts.delete(button);
                }, COPY_FEEDBACK_DURATION)
            );
        });
    });
})();
